const tracking = require('./tracking');
const shippingParty = require('./shipping-party');
const shippingMethod = require('./shipping-method');
const ctShippingAddress = require('./ct-shipping-address');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        shippingParties: {
            type: 'array',
            items: shippingParty
        },
        shippingMethod: shippingMethod,
        tracking: {
            oneOf: [
                tracking,
                {
                    type: ['null', 'string']
                }
            ]
        },
        shippingAddress: ctShippingAddress
    }
};
